import { render, staticRenderFns } from "./SharedContentPage.vue?vue&type=template&id=8a4dcd44&scoped=true"
import script from "./SharedContentPage.vue?vue&type=script&lang=ts"
export * from "./SharedContentPage.vue?vue&type=script&lang=ts"
import style0 from "./SharedContentPage.vue?vue&type=style&index=0&id=8a4dcd44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a4dcd44",
  null
  
)

export default component.exports